import React, {Component} from 'react';
import {BrowserRouter, Redirect, Route} from 'react-router-dom';
import PropTypes from 'prop-types';
import AppLayoutComponent from './containers/App';
import ScrollToTop from './components/App/ScrollToTop';
import {connect} from 'react-redux';
import * as _ from 'lodash';
import {DEFAULT_LANGUAGE} from './constants';

const Routes = () => (
    <BrowserRouter>
      <ScrollToTop>
        <AppLayoutComponent/>
      </ScrollToTop>
    </BrowserRouter>
);

class PrivateRouteComponent extends Component {
  render() {
    const {component: Component, isAuth, restaurant, ...rest} = this.props;
    let url = '/';
    const lng = this.props.language || DEFAULT_LANGUAGE;
    if (!_.isUndefined(restaurant)) {
      url = `/${lng}/${restaurant.name_for_url}/products/pizza`;
    }
    return (
        <Route {...rest}
           render={props => isAuth ? (
             <Component {...props} />
           ) : (
             <Redirect
               to={{
                 pathname: {url},
                 state: {from: props.location},
               }}
             />
           )}
        >
        </Route>
    );
  }
}

PrivateRouteComponent.propTypes = {
  isAuth: PropTypes.bool,
  component: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    isAuth: state.user.get('isAuth'),
    restaurant: state.restaurants.item,
    language: state.language.defaultLanguage
  };
}

const PrivateRoute = connect(mapStateToProps)(PrivateRouteComponent);

export {PrivateRoute, Routes};


// WEBPACK FOOTER //
// ./src/routes.js